var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('object',{attrs:{"type":"image/svg+xml","data":_vm.logoPath,"alt":(_vm.icon + " icon")}},[_vm._v(" hireful. ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }